import { render, staticRenderFns } from "./DashboardAlertNotification.vue?vue&type=template&id=73906995&scoped=true"
import script from "./DashboardAlertNotification.vue?vue&type=script&lang=ts&setup=true"
export * from "./DashboardAlertNotification.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./DashboardAlertNotification.vue?vue&type=style&index=0&id=73906995&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73906995",
  null
  
)

export default component.exports